module.exports = __webpack_public_path__ + "static/media/blood-healthcare-healthy-life-svgrepo-com.74c2c0a6.svg";